'use strict';

var Messenger = require('./messenger.js');

// 暂时不打算提供接口修改
var proxyUrl = '//is.alicdn.com/js/6v/biz/common/store-proxy/store-proxy2.html?iframe_delete=true';

// 分隔符
var spe2c = '-_-';
var spe2p = 'T_T';

// 用于判断 iframe 是否加载完毕
if (typeof window.__StoreProxyReady2 === 'undefined') {
    window.__StoreProxyReady2 = false;
}
var ready = window.__StoreProxyReady2;

// 所有callback被注册到全局的数组 __StoreProxyExec2 中
if (typeof window.__StoreProxyExec2 === 'undefined') {
    window.__StoreProxyExec2 = [];
}
// 该数组存放回调函数，将在 iframe 加载完毕后 统一调用.
var exec = window.__StoreProxyExec2;

function getId(id) {
    return document.getElementById(id);
}

/**
 * 创建 iframe
 * @param {Function} callback
 */
function createIframe(callback) {
    var id = 'localstorage-proxy-ifr-alibabadotcom2';
    var el = getId(id);
    // 已经存在
    if (el) {
        ready = window.__StoreProxyReady2;
        // 如果 iframe 还在加载中，则把回调函数保存在 exec 数组中，如果加载完毕，则直接调用。
        if (!ready) {
            exec.push(callback);
        } else {
            callback([el]);
        }
        return;
    }

    // 创建iframe
    el = document.createElement('iframe');
    el.id = id;
    el.src = proxyUrl;
    el.style.display = 'none';
    el.style.visibility = 'hidden';

    var time = void 0;
    time = setInterval(function () {
        if (el && el.contentWindow && el.Messenger) {
            for (var i = 0, len = exec.length; i < len; i++) {
                // 由于所有callback被注册到全局的数组__StoreProxyExec2中
                // 当定时器执行时，会将el传入，而部分场景使用的仍然是jQuery
                // 所以为兼容这些场景，必须传入数组
                exec[i]([el]);
            }
            exec.length = 0;
            ready = true;
            window.__StoreProxyReady2 = ready;
            clearInterval(time);
            time = 0;
        }
    }, 50);

    // load 事件
    el.onload = function () {
        if (time) {
            clearInterval(time);
            time = 0;
        }
        if (window.__StoreProxyReady2) {
            ready = true;
            return;
        }
        // 由于所有callback被注册到全局的数组__StoreProxyExec2中
        // 当定时器执行时，会将el传入，而部分场景使用的仍然是jQuery
        // 所以为兼容这些场景，必须传入数组
        for (var i = 0, l = exec.length; i < l; i++) {
            exec[i]([el]);
        }
        exec.length = 0;
        ready = true;
        window.__StoreProxyReady2 = ready;
    };

    exec.push(callback);
    document.body.appendChild(el);
}

// 获取 messenger 及 消息构成
var messenger = void 0;
var cbs = {};
var uid = 0;

/**
 * 创建 messager
 *
 */
function getMessenger() {
    return new Promise(function (success) {
        if (messenger) {
            success(messenger);
            return;
        }

        // 注册
        createIframe(function (el) {
            if (messenger) {
                success(messenger);
                return;
            }

            messenger = new Messenger('parent', 'store-proxy');
            messenger.addTarget(el[0].contentWindow, 'proxy');
            // 监听接口
            messenger.listen(function (msg) {
                parseMsg(msg);
            });
            success(messenger);
        });
    });
}

/**
 * 格式化操作，并且保存回调函数到 cbs 对象
 *
 * @param {*} op
 * @param {*} name
 * @param {*} value
 * @param {*} callback
 * @returns
 */
function getMsg(op, name, value, callback) {
    var msg = [op, name, value];
    if (op !== 'set') {
        callback = value;
        msg.pop();
        msg.push(uid);
        uid += 1;
    }
    // 转化为字符串，用于保存和作为 key
    msg = msg.join(spe2c);
    // 保存对应的回调函数
    cbs[msg] = callback;

    return msg;
}

/**
 * 处理监听返回的消息
 *
 * @param {*} msg
 */
function parseMsg(msg) {
    var tmp = msg.split(spe2p);

    msg = tmp[0];
    var err = tmp[1] || null;
    var data = tmp[2] || undefined;

    // 执行回调，返回结果
    if (cbs[msg]) {
        cbs[msg](err, data);
    }
}

module.exports = {
    // 根据键名获取存储的值
    get: function get(key, filter) {
        return new Promise(function (success, failure) {
            // 发信息
            getMessenger().then(function (msgr) {
                var target = msgr && msgr.targets && msgr.targets.proxy;
                target && target.send(getMsg('get', key, function (err, data) {
                    if (err) {
                        failure(err);
                        return false;
                    }
                    // 检验 value
                    if (typeof filter === 'function') {
                        data = filter(data);
                    }
                    success(data);
                }));
            });
        });
    },

    // 设置数据
    set: function set(key, value, filter) {
        return new Promise(function (success, failure) {
            // 检验 value
            if (typeof filter === 'function') {
                value = filter(value);
            }

            if (!isString(value)) {
                failure(new Error('value must be String in "storeProxy2.set"!'));
            }

            // 发信息
            getMessenger().then(function (msgr) {
                var target = msgr && msgr.targets && msgr.targets.proxy;
                target && target.send(getMsg('set', key, value, function (err) {
                    if (err) {
                        failure(err);
                    } else {
                        success(true);
                    }
                }));
            });
        });
    },

    // 移除指定键名的存储
    remove: function remove(key) {
        return new Promise(function (success, failure) {
            // 发信息
            getMessenger().then(function (msgr) {
                var target = msgr && msgr.targets && msgr.targets.proxy;
                target && target.send(getMsg('remove', key, function (err) {
                    if (err) {
                        failure(err);
                    } else {
                        success(true);
                    }
                }));
            });
        });
    }
};

function isString(val) {
    return Object.prototype.toString.call(val) === '[object String]';
}